import { useRef } from "react";
import { severityOptions } from "../util/constants";

const messages = {
  [severityOptions.success]: 'Thank you! Your feedback has been submitted successfully.',
  [severityOptions.error]: 'Error - There was a problem submitting your feedback. Please review your form and submit again.',
  [severityOptions.info]: 'Submitting your feedback...',
}

const Alert = ({ severity: propsSeverity, overrideErrors }) => {
  const alertRef = useRef()
  const severity = overrideErrors?.length ? severityOptions.error : propsSeverity
  const description = overrideErrors?.length ? ("Error - " + overrideErrors.join(" ")) : (severity && messages[severity])

  return (
    <Alert
      ref={alertRef}
      severity={severity}
      description={description}
    />
  );
};

export default Alert;
